import "../panchangam/panchangam.css";
import "./monthlyevents.css";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Box, Tab, Typography } from "@mui/material";
import Today from "./monthlyevents/Today";
import Monthly from "./monthlyevents/Monthly";
import Weekly from "./monthlyevents/Weekly";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import DateRangeIcon from "@mui/icons-material/DateRange";
import TodayIcon from "@mui/icons-material/Today";
import { logEvent } from "../../../../utils/analytics";
import React, { useEffect } from "react";
import { useUpcomingEventsMasterHook } from "../../customHooks";
import {Button} from "@mui/material";
import { useNavigate } from "react-router-dom";
import TitleBox from "../../../../components/common/titleBox/TitleBox";

function UpcommingEvents(props) {
  const navigate = useNavigate();
  const { events, tab, fetchEvents, handleChange } =
    useUpcomingEventsMasterHook();

  useEffect(() => {
    fetchEvents();
  }, []);

  return (
    <React.Fragment>
      <div className="text-center h-100 pt-0 panchang">
        <React.Fragment>
          <Box title={tab}>
            <Box>
              <Box sx={{ width: "100%", typography: "body1" }}>
                <TabContext value={tab}>
                    <TitleBox
                          title={    <div className="title-bg d-flex justify-content-around align-items-center">
                      <div>
                        <h2>Upcoming Events</h2>
                      </div>
                      <div>
                        <TabList
                          centered
                          onChange={handleChange}
                          aria-label="lab API tabs example"
                          textColor="blue"
                          indicatorColor="blue"
                          sx={{
                            "& .MuiTabs-indicator": {
                              backgroundColor: "white",
                            },
                            "& .css-1wf8b0h-MuiTabs-flexContainer": {
                              height: "30px",
                            },
                          }}
                        >
                          <Tab
                            icon={
                              <CalendarMonthIcon
                                sx={{
                                  "&.MuiTab-iconWrapper": {
                                    marginRight: "1px !important",
                                  },
                                }}
                              />
                            }
                            iconPosition="start"
                            label="Monthly"
                            value="Monthly"
                            sx={{
                              textTransform: "inherit",
                              height: "100%",
                              color: "white",
                              padding: "10px",
                              minHeight: "50px",
                              "&.Mui-selected": { color: "white" },
                            }}
                          />

                          <Tab
                            icon={
                              <DateRangeIcon
                                sx={{
                                  "&.MuiTab-iconWrapper": {
                                    marginRight: "1px !important",
                                  },
                                }}
                              />
                            }
                            iconPosition="start"
                            label="Weekly"
                            value="Weekly"
                            sx={{
                              textTransform: "inherit",
                              height: "100%",
                              color: "white",
                              padding: "10px",
                              minHeight: "50px",
                              "&.Mui-selected": { color: "white" },
                            }}
                          />
                          <Tab
                            icon={
                              <TodayIcon
                                sx={{
                                  "&.MuiTab-iconWrapper": {
                                    marginRight: "1px !important",
                                  },
                                }}
                              />
                            }
                            iconPosition="start"
                            label="Today"
                            value="Today"
                            sx={{
                              textTransform: "inherit",
                              color: "white",
                              height: "100%",
                              padding: "10px",
                              minHeight: "50px",
                              "&.Mui-selected": { color: "white" },
                            }}
                          />
                        </TabList>
                      </div>
                    </div>}
                          subcontent={
                            <div className="sub-title-bg">
                            <a
                              href={`/calenderview?view=${tab.toLowerCase()}`}
                              onClick={(e) => {
                                logEvent("Home Page", "Calender View Clicked");
                              }}
                            >
                              <CalendarMonthIcon /> Calendar View
                            </a>
                          </div>
                          }
                          content={
                            <Box
                            sx={{
                              maxHeight: "428px",
                              width: "100%",
                              overflowY: "auto",
                              backgroundColor: "#ffffff",
                              height: "428px",
                              width: "100%",
                              "& .actions": {
                                color: "text.secondary",
                              },
                              "& .textPrimary": {
                                color: "text.primary",
                              },
                            }}
                          >
                            <TabPanel value="Today">
                              <Today events={events?.today} />
                            </TabPanel>
                            <TabPanel value="Weekly">
                              <Weekly events={events?.weekly} />
                            </TabPanel>
                            <TabPanel value="Monthly">
                              <Monthly events={events?.monthly} />
                            </TabPanel>
                          </Box>
                          }
                        ></TitleBox>                 
                </TabContext>
              </Box>
            </Box>
            <div className="bottom-more">
              <Typography variant="p">
                <Button
                  onClick={()=>{
                    navigate('/calenderview?view=agenda')
                  }}
                  variant="contained"
                  color="primary"
                  className="text-white"
                >
                  View all
                </Button>
              </Typography>
            </div>
          </Box>
        </React.Fragment>
      </div>
    </React.Fragment>
  );
}
export default UpcommingEvents;
